import { render, staticRenderFns } from "./flight-booking.vue?vue&type=template&id=69160686&"
import script from "./flight-booking.vue?vue&type=script&lang=js&"
export * from "./flight-booking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports